﻿﻿export interface IInvoice {
    id: number;
    invoiceNumber: number;
    centerId: number;
    centerAlias: string;
    centerName: string;
    invoiceYear: number;
    invoiceMonth: number;
    transplantCount: number;
    amountDue: number;
    stopLateNoticesUntil: string;
    amountPaid: number;
    annualMembershipFee: number;
    annualDcnFee: number;
    technologySupportFee: number;
    customLineItemFee: number;
    nkrFee: number;
    dashFee: number;
    crossMatchFee: number;
    crossMatchVibtFee: number;
    vxmFee: number;
    serologyFee: number;
    serologyFeeDirect: number;
    logisticsFee: number;
    shippingFee: number;
    transplantFee: number;
    opoFee: number;
    dppFee: number;
    typingFee: number;
    researchSupportFee: number;
    donorInsuranceAndSupport: number;
    streamlinedBillingFee: number;
    ctFee: number;
    medicaidFee: number;
    homeBloodDrawFee: number;
    covid19Fee: number;
    phlebotFee: number;
    donorShieldFee: number;
    pwlQuestFee: number;
    pwlPhlebotFee: number;
    pwlJugOnlyFee: number;
    physicianCharge: number;
    anesthesiaCharge: number;
    hospitalCharge: number;
    accFee: number;
    isMissingTransportCosts: boolean;
    sentDateTime: string;
    receivedDateTime: string;
    viewKey: string;
    comments: string;
    createdDateTime: string;
    updatedDateTime: string;
    userIdCreatedBy: number;
    createdBy: string;
    userIdSentBy: number;
    sentBy: string;
    protectedReportEndDatea: string;
}
